import { ViewOfferButton } from 'components/OfferList/OfferCards/ViewOfferButton'
import TextButton from 'LuxKit/Button/TextButton'

function SearchTilePrimaryActionButton() {
  return <TextButton nonInteractable kind="primary">
    <ViewOfferButton variant="default" textOnly />
  </TextButton>
}

export default SearchTilePrimaryActionButton
